import * as S from "./styles.ts";
import useBreakpoint from "@/lib/helpers/hooks/useBreakpoint.ts";
import { UniversalLink } from "@template/components";

export type TLink = {
  url: string;
  label: string;
  description?: string;
  title?: string;
};

interface ILinkComponentProps {
  link: TLink;
}

const LinkComponent = ({ link }: ILinkComponentProps) => {
  const { check: isBig } = useBreakpoint("md");

  return (
    <UniversalLink
      href={link.url}
      title={link.title}
    >
      <S.LinkContainer>
        <S.LinkLabel>{link.label}</S.LinkLabel>
        {link.description && isBig && (
          <S.LinkDescription>{link.description}</S.LinkDescription>
        )}
      </S.LinkContainer>
    </UniversalLink>
  );
};

export default LinkComponent;
